<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'Formations'
});
</script>
<template>
  <ka-container
    code="bibliotheque-de-formations"
    :data="page.$info.bibliothequeDeFormations">
    <!-- Container de page -->
    <ka-container code="container-de-page">
      <!-- Container Titre -->
      <ka-container code="container-titre">
        <!-- Container Textes -->
        <ka-container code="container-textes">
          <ka-text code="une-bibliotheque-de">
            <h1 v-html="t('bibliothequeDeFormations.containerDePage.containerTitre.containerTextes.uneBibliothequeDe.value', `Une bibliothèque de formations pas comme les autres`)" />
          </ka-text>
          <ka-text code="nous-naimons-pas-vraiment">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerTitre.containerTextes.nousNaimonsPasVraiment.value', `Nous n'aimons pas vraiment les formations sur “étagères”. Chez Matchers, le<strong> sur-mesure</strong> est à l’honneur. Pourtant, dire que nous pouvons tout faire, revient à ne pas dire grand chose. <br> <br>Afin de vous donner une idée des projets dans lesquels notre accompagnement est pertinent, nous vous proposons ici <strong>un échantillon des formations </strong>qui nous sont le plus demandées.`)" />
          </ka-text>
        </ka-container>
        <ka-image
          code="image"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Matchers vous met à disposition une bibliothèque de formations adaptables selon les besoins de votre entreprise !`
          }"
          value="https://ucarecdn.com/6516239f-737c-473d-8bda-b20528660a0b/" />
      </ka-container>
      <!-- Container mots clés -->
      <ka-container code="container-mots-cles">
        <!-- Container -->
        <ka-container code="container">
          <ka-text code="les-mots-cles-qui-vous">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.lesMotsClesQuiVous.value', `Les mots clés qui vous intéressent`)" />
          </ka-text>
          <ka-separator code="separator" />
          <ka-button
            code="acquisition-digitale"
            :options="{
              ripple: true,
              href: { hash: `#marketing--p40` },
              ariaLabel: `button`,
              click: page.acquisitionDigitaleClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.acquisitionDigitale.value', `Acquisition digitale`)" />
          </ka-button>
          <ka-button
            code="referencement"
            :options="{
              ripple: true,
              href: { hash: `#container-1--p40` },
              ariaLabel: `button`,
              click: page.referencementClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.referencement.value', `Référencement`)" />
          </ka-button>
          <ka-button
            code="e-commerce"
            :options="{
              ripple: true,
              href: { hash: `#container-12--p40` },
              ariaLabel: `button`,
              click: page.eCommerceClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.eCommerce.value', `E-commerce`)" />
          </ka-button>
          <ka-button
            code="communication-digitale"
            :options="{
              ripple: true,
              href: { hash: `#communication--p40` },
              ariaLabel: `button`,
              click: page.communicationDigitaleClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.communicationDigitale.value', `Communication digitale`)" />
          </ka-button>
          <ka-button
            code="financement"
            :options="{
              ripple: true,
              href: { hash: `#container-formations--p40` },
              ariaLabel: `button`,
              click: page.financementClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.financement.value', `Financement`)" />
          </ka-button>
          <ka-button
            code="management"
            :options="{
              ripple: true,
              href: { hash: `#container-formations--p40` },
              ariaLabel: `button`,
              click: page.managementClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.management.value', `Management`)" />
          </ka-button>
          <ka-button
            code="gestion-de-projets"
            :options="{
              ripple: true,
              href: { hash: `#container-formations--p40` },
              ariaLabel: `button`,
              click: page.gestionDeProjetsClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.gestionDeProjets.value', `Gestion de projets`)" />
          </ka-button>
          <ka-button
            code="ressources-humaines"
            :options="{
              ripple: true,
              href: { hash: `#container-formations--p40` },
              ariaLabel: `button`,
              click: page.ressourcesHumainesClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.ressourcesHumaines.value', `Ressources humaines`)" />
          </ka-button>
          <ka-button
            code="seo"
            :options="{
              ripple: true,
              href: { hash: `#container-1--p40` },
              ariaLabel: `button`,
              click: page.seoClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.seo.value', `SEO`)" />
          </ka-button>
          <ka-button
            code="levee-de-fonds"
            :options="{
              ripple: true,
              href: { hash: `#container-formations--p40` },
              ariaLabel: `button`,
              click: page.leveeDeFondsClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.leveeDeFonds.value', `Levée de fonds`)" />
          </ka-button>
          <ka-button
            code="vente"
            :options="{
              ripple: true,
              href: { hash: `#marketing--p40` },
              ariaLabel: `button`,
              click: page.venteClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.vente.value', `Vente`)" />
          </ka-button>
          <ka-button
            code="ui-ux-design"
            :options="{
              ripple: true,
              href: { hash: `#communication--p40` },
              ariaLabel: `button`,
              click: page.uiUxDesignClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.uiUxDesign.value', `UI/UX design`)" />
          </ka-button>
          <ka-button
            code="logistique"
            :options="{
              ripple: true,
              href: undefined,
              ariaLabel: `button`,
              click: page.logistiqueClick,
              hidden: null
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.logistique.value', `Logistique`)" />
          </ka-button>
          <ka-button
            code="relation-client"
            :options="{
              ripple: true,
              href: { hash: `#container-12--p40` },
              ariaLabel: `button`,
              click: page.relationClientClick
            }">
            <span v-html="t('bibliothequeDeFormations.containerDePage.containerMotsCles.container.relationClient.value', `Relation client`)" />
          </ka-button>
        </ka-container>
      </ka-container>
      <!-- Les formations -->
      <ka-container code="les-formations">
        <!-- Référencement -->
        <ka-container code="container-1">
          <ka-text code="titre-referencement">
            <h2 v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.container1.titreReferencement.value', `Référencement`)" />
          </ka-text>
          <!-- Briques -->
          <ka-container code="briques">
            <!-- SEO -->
            <ka-container
              code="container-2"
              :options="{
                href: { name: `Formations-Seo` },
                click: page.container2Click
              }">
              <ka-text code="referencement-seo">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.container1.briques.container2.referencementSeo.value', `Référencement - SEO`)" />
              </ka-text>
              <ka-text code="lun-de-nos-experts">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.container1.briques.container2.lunDeNosExperts.value', `L’un de nos experts peut vous accompagner dans la mise en place d’une stratégie SEO ou la préparation d’un plan de migration lors d’une refonte.`)" />
              </ka-text>
              <ka-button
                code="consulter"
                :options="{
                  ripple: true,
                  href: { name: `Formations-Seo` },
                  click: page.consulterClick
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.container1.briques.container2.consulter.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <!-- SEA -->
            <ka-container
              code="sea"
              :options="{
                href: { name: `Formations-Sea` },
                click: page.seaClick
              }">
              <ka-text code="text-1">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.container1.briques.sea.text1.value', `SEA`)" />
              </ka-text>
              <ka-text code="la-publicite-pilotee">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.container1.briques.sea.laPublicitePilotee.value', `La publicité pilotée et pensée à l’échelle de votre entreprise. Cette formation se base sur les outils ainsi que les ressources humaines et monétaires dont vous disposez. `)" />
              </ka-text>
              <ka-button
                code="button-1"
                :options="{
                  ripple: true,
                  href: { name: `Formations-Sea` },
                  click: page.button1Click
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.container1.briques.sea.button1.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <BlocArg
              instance-class="bloc-arg--p40"
              taille-texte="1.1" />
          </ka-container>
        </ka-container>
        <!-- Marketing -->
        <ka-container code="marketing">
          <ka-text code="titre-acquisition">
            <h2 v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.titreAcquisition.value', `Formations liées à l’acquisition & funnel de vente`)" />
          </ka-text>
          <!-- Briques -->
          <ka-container code="container-3">
            <!-- Marketing digital -->
            <ka-container
              code="marketing-digital"
              :options="{
                href: { name: `Formations-marketing-digital` },
                click: page.marketingDigitalClick
              }">
              <ka-text code="text-2">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.marketingDigital.text2.value', `Marketing digital`)" />
              </ka-text>
              <ka-text code="bien-que-generer-et">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.marketingDigital.bienQueGenererEt.value', `Bien que générer et convertir des leads soit un objectif commun à toutes les entreprises, les moyens pour y parvenir différent de l’une à l’autre.`)" />
              </ka-text>
              <ka-button
                code="button-2"
                :options="{
                  ripple: true,
                  href: { name: `Formations-marketing-digital` },
                  click: page.button2Click
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.marketingDigital.button2.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <!-- Growth hacking -->
            <ka-container
              code="growth-hacking"
              :options="{
                href: { name: `Formations-growth-hacking` },
                click: page.growthHackingClick
              }">
              <ka-text code="text-3">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.growthHacking.text3.value', `Growth hacking `)" />
              </ka-text>
              <ka-text code="vous-souhaitez-gagner">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.growthHacking.vousSouhaitezGagner.value', `Vous souhaitez gagner du temps en automatisant plusieurs de vos actions ? Coupler vos actions automatisées avec votre CRM ?`)" />
              </ka-text>
              <ka-button
                code="button-3"
                :options="{
                  ripple: true,
                  href: { name: `Formations-growth-hacking` },
                  click: page.button3Click
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.growthHacking.button3.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <!-- Sales -->
            <ka-container
              code="sales"
              :options="{
                href: { name: `Formations-business-developer` },
                click: page.salesClick
              }">
              <ka-text code="business-development">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.sales.businessDevelopment.value', `Business development`)" />
              </ka-text>
              <ka-text code="cette-formation-malleable">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.sales.cetteFormationMalleable.value', `Cette formation malléable peut vous donner une vision d’ensemble, ou bien se focaliser sur une étape de votre processus de vente (ex : cold calling).`)" />
              </ka-text>
              <ka-button
                code="button-4"
                :options="{
                  ripple: true,
                  href: { name: `Formations-business-developer` },
                  click: page.button4Click
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.sales.button4.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <!-- Vente grands comptes -->
            <ka-container
              code="vente-grands-comptes"
              :options="{ hidden: null }">
              <ka-text code="text-4">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.venteGrandsComptes.text4.value', `Vente grands comptes`)" />
              </ka-text>
              <ka-text code="reussissez-et-multipliez">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.venteGrandsComptes.reussissezEtMultipliez.value', `Réussissez et multipliez vos ventes complexes. Notre expert pourra vous accompagner sur plusieurs semaines pour vous conseiller à chaque étape.`)" />
              </ka-text>
              <ka-button
                code="button-5"
                :options="{ ripple: true }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.venteGrandsComptes.button5.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <!-- Argument -->
            <ka-container code="argument">
              <ka-text code="vous-aviez-autre-chose">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.marketing.container3.argument.vousAviezAutreChose.value', `Vous aviez autre chose en tête ? Alors <span style='color:#D93174FF;'>faisons autre chose</span> ! Nos formations n’ont aucune limite.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
        <!-- Communication -->
        <ka-container code="communication">
          <ka-text code="titre-communication">
            <h2 v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.titreCommunication.value', `Formations liées à la communication`)" />
          </ka-text>
          <!-- Briques -->
          <ka-container code="container-4">
            <!-- Communication digitale -->
            <ka-container code="container-5">
              <ka-text code="text-5">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.container4.container5.text5.value', `Communication digitale`)" />
              </ka-text>
              <ka-text code="notre-communaute-dexperts">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.container4.container5.notreCommunauteDexperts.value', `Notre communauté d’experts est composée de professionnels en matière de communication digitale issus de multiples secteurs d’activité.`)" />
              </ka-text>
              <ka-button
                code="button-6"
                :options="{
                  ripple: true,
                  href: { name: `Formations-communication-digitale` },
                  click: page.button6Click
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.container4.container5.button6.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <!-- Réseaux sociaux -->
            <ka-container code="reseaux-sociaux">
              <ka-text code="text-6">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.container4.reseauxSociaux.text6.value', `Réseaux sociaux`)" />
              </ka-text>
              <ka-text code="pour-avoir-une-vision">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.container4.reseauxSociaux.pourAvoirUneVision.value', `Pour avoir une vision globale ou se spécialiser sur l’un d’eux (LinkedIn, Instagram, Facebook, TikTok, Twitter, Twitch, YouTube...)`)" />
              </ka-text>
              <ka-button
                code="button-7"
                :options="{
                  ripple: true,
                  href: { name: `Formations-reseaux-sociaux` },
                  click: page.button7Click
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.container4.reseauxSociaux.button7.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <!-- Relation presse -->
            <ka-container
              code="relation-presse"
              :options="{
                href: { name: `Formations-relations-presse` },
                click: page.relationPresseClick
              }">
              <ka-text code="relations-presse">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.container4.relationPresse.relationsPresse.value', `Relations presse`)" />
              </ka-text>
              <ka-text code="faites-parler-de-votre">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.container4.relationPresse.faitesParlerDeVotre.value', `Faites parler de votre produit, de votre service en maîtrisant les codes pour atteindre les médias qui correspondent à votre objectif.`)" />
              </ka-text>
              <ka-button
                code="button-8"
                :options="{
                  ripple: true,
                  href: { name: `Formations-relations-presse` },
                  click: page.button8Click
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.container4.relationPresse.button8.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <!-- UI/UX design -->
            <ka-container code="container-6">
              <ka-text code="text-7">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.container4.container6.text7.value', `UI/UX design`)" />
              </ka-text>
              <ka-text code="cette-formation-peut">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.container4.container6.cetteFormationPeut.value', `Cette formation peut vous permettre de maîtriser et appliquer les concepts d'ergonomie et d'UX/UI Design et scénariser l'expérience utilisateur.`)" />
              </ka-text>
              <ka-button
                code="button-9"
                :options="{
                  ripple: true,
                  href: { name: `Formations-ui-ux-design` },
                  click: page.button9Click
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.lesFormations.communication.container4.container6.button9.value', `Consulter`)" />
              </ka-button>
            </ka-container>
          </ka-container>
        </ka-container>
      </ka-container>
      <!-- Contact -->
      <ka-container
        code="contact"
        inner>
        <ka-text code="titre">
          <span v-html="t('bibliothequeDeFormations.containerDePage.contact.titre.value', `Rien dans cette liste ne correspond à vos attentes ?`)" />
        </ka-text>
        <ka-text code="description">
          <span v-html="t('bibliothequeDeFormations.containerDePage.contact.description.value', `Ça tombe bien ! 👌 Ce n’est qu’un échantillon de formations. N’hésitez pas à contacter notre équipe si vous souhaitez être accompagné sur un outil de pointe ou une thématique particulière. Notre communauté de plus de 500 experts regroupe un grand nombre de compétences et maîtrise un large panel d’outils. `)" />
        </ka-text>
        <ka-button
          code="prendre-rendez-vous"
          :options="{
            ripple: true,
            href: { name: `Contact` },
            click: page.prendreRendezVousClick
          }"
          inner>
          <span v-html="t('bibliothequeDeFormations.containerDePage.contact.prendreRendezVous.value', `Contactez-nous`)" />
        </ka-button>
      </ka-container>
      <!-- Les formations -->
      <ka-container code="container-7">
        <!-- Container formations -->
        <ka-container code="container-formations">
          <ka-text code="titre-structuration">
            <h2 v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.titreStructuration.value', `Formations liées à la structuration de l’entreprise`)" />
          </ka-text>
          <!-- Briques -->
          <ka-container code="container-8">
            <!-- Levée de fonds -->
            <ka-container code="container-9">
              <ka-text code="text-8">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.container9.text8.value', `Levée de fonds`)" />
              </ka-text>
              <ka-text code="pour-vous-accompagner">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.container9.pourVousAccompagner.value', `Pour vous accompagner dans le processus ou initier la levée de fonds, vous pouvez choisir d'être accompagné par un expert.`)" />
              </ka-text>
              <ka-button
                code="button-10"
                :options="{
                  ripple: true,
                  href: { name: `Formations-levee-de-fonds` },
                  click: page.button10Click
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.container9.button10.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <!-- RH -->
            <ka-container code="rh">
              <ka-text code="text-9">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.rh.text9.value', `Ressources humaines`)" />
              </ka-text>
              <ka-text code="les-ressources-humaines">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.rh.lesRessourcesHumaines.value', `Les ressources humaines présentent un large éventail d'expertises, grâce à nos experts nous les regroupons toutes (paie, droit social.. etc).`)" />
              </ka-text>
              <ka-button
                code="button-11"
                :options="{
                  ripple: true,
                  href: { name: `Formations-ressources-humaines` },
                  click: page.button11Click
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.rh.button11.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <!-- Management -->
            <ka-container code="container-10">
              <ka-text code="text-10">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.container10.text10.value', `Management`)" />
              </ka-text>
              <ka-text code="aider-vos-managers">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.container10.aiderVosManagers.value', `Aider vos managers dans leur prise de responsabilité, résoudre un conflit, développer votre leadership, tout est possible avec le sur-mesure.`)" />
              </ka-text>
              <ka-button
                code="button-12"
                :options="{
                  ripple: true,
                  href: { name: `Formations-Management` },
                  click: page.button12Click
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.container10.button12.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <!-- Gestion de projets -->
            <ka-container code="container-11">
              <ka-text code="text-11">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.container11.text11.value', `Gestion de projets`)" />
              </ka-text>
              <ka-text code="developpez-la-methode">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.container11.developpezLaMethode.value', `Développez la méthode agile pour optimiser le travail de vos équipes et mettez en place les outils digitaux pour fluidifier le travail d'équipe. `)" />
              </ka-text>
              <ka-button
                code="button-13"
                :options="{
                  ripple: true,
                  href: { name: `Formations-gestion-de-projets` },
                  click: page.button13Click
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.container11.button13.value', `Consulter`)" />
              </ka-button>
            </ka-container>
            <!-- RGPD -->
            <ka-container code="rgpd">
              <ka-text code="text-12">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.rgpd.text12.value', `RGPD`)" />
              </ka-text>
              <ka-text code="mettez-en-place-des">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.rgpd.mettezEnPlaceDes.value', `Mettez en place des actions immédiates pour assurer la sécurité et la confidentialité des données que vous traitez conformément au RGPD.`)" />
              </ka-text>
              <ka-button
                code="button-14"
                :options="{
                  ripple: true,
                  hidden: null
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.rgpd.button14.value', `Consulter`)" />
              </ka-button>
              <ka-button
                code="page-en-cours-de-creation"
                :options="{ ripple: true }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.containerFormations.container8.rgpd.pageEnCoursDeCreation.value', `Page en cours de création`)" />
              </ka-button>
            </ka-container>
          </ka-container>
        </ka-container>
        <!-- Container formations -->
        <ka-container code="container-12">
          <ka-text code="titre-business-en-ligne">
            <h2 v-html="t('bibliothequeDeFormations.containerDePage.container7.container12.titreBusinessEnLigne.value', `Business en ligne`)" />
          </ka-text>
          <!-- Briques -->
          <ka-container code="container-13">
            <!-- E-commerce -->
            <ka-container code="container-14">
              <ka-text code="text-13">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container12.container13.container14.text13.value', `E-commerce`)" />
              </ka-text>
              <ka-text code="faites-vous-accompagner">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container12.container13.container14.faitesVousAccompagner.value', `Faites vous accompagner par un professionnel du e-commerce qui connaît votre CMS et votre secteur d'activité. `)" />
              </ka-text>
              <ka-button
                code="button-15"
                :options="{ ripple: true }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container12.container13.container14.button15.value', `Page en cours de création`)" />
              </ka-button>
            </ka-container>
            <!-- Marketplace -->
            <ka-container
              code="marketplace"
              :options="{ hidden: null }">
              <ka-text code="text-14">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container12.container13.marketplace.text14.value', `Marketplace`)" />
              </ka-text>
              <ka-text code="texte-a-ajoutertexte">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container12.container13.marketplace.texteAAjoutertexte.value', `texte à ajoutertexte à ajoutertexte à ajoutertexte à ajoutertexte à ajoutertexte à ajouter`)" />
              </ka-text>
              <ka-button
                code="button-16"
                :options="{ ripple: true }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container12.container13.marketplace.button16.value', `Page en cours de création`)" />
              </ka-button>
            </ka-container>
            <!-- Relation client -->
            <ka-container code="container-15">
              <ka-text code="relation-client-csm">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container12.container13.container15.relationClientCsm.value', `Relation client - CSM`)" />
              </ka-text>
              <ka-text code="mettez-en-place-les">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container12.container13.container15.mettezEnPlaceLes.value', `Mettez en place les bonnes pratiques du suivi client et apprenez à gérer les clients difficiles en BtoB ou BtoC grâce à l'un de nos experts.`)" />
              </ka-text>
              <ka-button
                code="button-17"
                :options="{
                  ripple: true,
                  hidden: null
                }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container12.container13.container15.button17.value', `Consulter`)" />
              </ka-button>
              <ka-button
                code="button-18"
                :options="{ ripple: true }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container12.container13.container15.button18.value', `Page en cours de création`)" />
              </ka-button>
            </ka-container>
          </ka-container>
        </ka-container>
        <!-- Container formations -->
        <ka-container
          code="container-16"
          :options="{ hidden: null }">
          <ka-text code="text-15">
            <h2 v-html="t('bibliothequeDeFormations.containerDePage.container7.container16.text15.value', `Autres thématiques`)" />
          </ka-text>
          <!-- Briques -->
          <ka-container code="container-17">
            <!-- Logistique -->
            <ka-container
              code="container-18"
              :options="{ hidden: null }">
              <ka-text code="text-16">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container16.container17.container18.text16.value', `Logistique`)" />
              </ka-text>
              <ka-text code="text-17">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container16.container17.container18.text17.value', `texte à ajoutertexte à ajoutertexte à ajouter texte à ajoutertexte à ajoutertexte à ajouter`)" />
              </ka-text>
              <ka-button
                code="button-19"
                :options="{ ripple: true }">
                <span v-html="t('bibliothequeDeFormations.containerDePage.container7.container16.container17.container18.button19.value', `Page en cours de création`)" />
              </ka-button>
            </ka-container>
          </ka-container>
        </ka-container>
      </ka-container>
      <!-- Pourquoi se former avec Matchers ? -->
      <ka-container code="pourquoi-se-former-avec-matchers">
        <ka-text code="text-18">
          <h2 v-html="t('bibliothequeDeFormations.containerDePage.pourquoiSeFormerAvecMatchers.text18.value', `Pourquoi se former avec Matchers ? `)" />
        </ka-text>
        <!-- Conteneur -->
        <ka-container code="conteneur">
          <!-- Bloc texte -->
          <ka-container code="bloc-texte">
            <ka-icon
              code="icone"
              value="i-fa-solid:lightbulb"
              inner />
            <ka-text code="un-genie-en-matiere">
              <h3 v-html="t('bibliothequeDeFormations.containerDePage.pourquoiSeFormerAvecMatchers.conteneur.blocTexte.unGenieEnMatiere.value', `Un génie en matière de financement de formation.`)" />
            </ka-text>
          </ka-container>
          <!-- Bloc texte -->
          <ka-container code="container-19">
            <ka-icon
              code="icon-1"
              value="i-fa-solid:rocket"
              inner />
            <ka-text code="une-pedagogie-qui-fait">
              <h3 v-html="t('bibliothequeDeFormations.containerDePage.pourquoiSeFormerAvecMatchers.conteneur.container19.unePedagogieQuiFait.value', `Une pédagogie qui fait avancer votre boîte et vos projets.`)" />
            </ka-text>
          </ka-container>
          <!-- Bloc texte -->
          <ka-container code="container-20">
            <ka-icon
              code="icon-2"
              value="i-fa-solid:certificate"
              inner />
            <ka-text code="le-modele-de-formation">
              <h3 v-html="t('bibliothequeDeFormations.containerDePage.pourquoiSeFormerAvecMatchers.conteneur.container20.leModeleDeFormation.value', `LE modèle de formation pratique par excellence.`)" />
            </ka-text>
          </ka-container>
        </ka-container>
      </ka-container>
      <!-- Pourquoi se former avec Matchers ? -->
      <ka-container code="container-21">
        <ka-text code="les-formations-matchers">
          <h2 v-html="t('bibliothequeDeFormations.containerDePage.container21.lesFormationsMatchers.value', `Les formations Matchers en quelques chiffres`)" />
        </ka-text>
        <!-- Bloc texte -->
        <ka-container code="container-22">
          <!-- Conteneur -->
          <ka-container code="container-23">
            <ka-text code="k-300">
              <h3 v-html="t('bibliothequeDeFormations.containerDePage.container21.container22.container23.k300.value', `<strong>300</strong>`)" />
            </ka-text>
            <ka-text code="entreprises-accompagnees">
              <h3 v-html="t('bibliothequeDeFormations.containerDePage.container21.container22.container23.entreprisesAccompagnees.value', `Entreprises accompagnées`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <!-- Bloc texte -->
        <ka-container code="container-24">
          <!-- Conteneur -->
          <ka-container code="container-25">
            <ka-text code="k-91110">
              <h3 v-html="t('bibliothequeDeFormations.containerDePage.container21.container24.container25.k91110.value', `9,11 / 10`)" />
            </ka-text>
            <ka-text code="estiment-avoir-acquis">
              <h3 v-html="t('bibliothequeDeFormations.containerDePage.container21.container24.container25.estimentAvoirAcquis.value', `Estiment avoir acquis de nouvelles compétences opérationnelles`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <!-- Bloc texte -->
        <ka-container code="container-26">
          <!-- Conteneur -->
          <ka-container code="container-27">
            <ka-text code="k-93910">
              <h3 v-html="t('bibliothequeDeFormations.containerDePage.container21.container26.container27.k93910.value', `9,39 / 10`)" />
            </ka-text>
            <ka-text code="satisfaction-de-nos">
              <h3 v-html="t('bibliothequeDeFormations.containerDePage.container21.container26.container27.satisfactionDeNos.value', `Satisfaction de nos formations par nos stagiaires`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <!-- Bloc texte -->
        <ka-container code="container-28">
          <!-- Conteneur -->
          <ka-container code="container-29">
            <ka-text code="k7500">
              <h3 v-html="t('bibliothequeDeFormations.containerDePage.container21.container28.container29.7500.value', `<strong>+7 500</strong>`)" />
            </ka-text>
            <ka-text code="heures-de-formations">
              <h3 v-html="t('bibliothequeDeFormations.containerDePage.container21.container28.container29.heuresDeFormations.value', `Heures de formations`)" />
            </ka-text>
          </ka-container>
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { formations } from './store'
import BlocArg from '~/components/BlocArg/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p40')
const appData = appDataStore()
const page = formations()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
